module.exports = __webpack_public_path__ + "fonts/BebasNeue-Regular.21bb70b6.ttf";